import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private subjectUpdate: Subject<any>;
  private subjectRefresh: Subject<any>;

  public splitPaneVisible: boolean;

  constructor() {
    this.subjectUpdate = new Subject<any>();
    this.subjectRefresh = new Subject<any>();
  }

  public updateViewListener(): Observable<any> {
    return this.subjectUpdate.asObservable();
  }

  public updateView() {
    this.subjectUpdate.next(null);
  }

  public callEndpointsListener(): Observable<any> {
    return this.subjectRefresh.asObservable();
  }

  public callEndpoints() {
    this.subjectRefresh.next(null);
  }
}